module.exports = __webpack_public_path__ + "img/avatar1.28bdbc85.png";